// extracted by mini-css-extract-plugin
export default {"container":"_3ODSeaIECwO12urx6speoB"};